// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 408 ? "layout-worker" : chunkId) + "." + {"408":"787b3e34","453":"683b28f1"}[chunkId] + ".chunk.js";
};